import RouterMixin from 'Arch/mixins/RouterMixin';
import NotificationMixin from 'Arch/mixins/NotificationMixin';

export default {
  mixins: [NotificationMixin, RouterMixin],
  data: () => ({
    showSuccessToastMessage: true,
    successToasMessageCreate: 'Os dados foram cadastrados.',
    formsRef: 'form',
    formValid: false,
    loadEntityOnCreate: true,
    loadingForm: false,
  }),
  created() {
    this.makeEditSetCall();
    this.manualSendForm();
  },
  computed: {
    entityId() {
      return this.lockGetIdParams ? this.staticId : this.$route.params.id;
    },
  },
  inject: {
    setDataLoading: {
      default() {
        return () => {};
      },
    },
  },
  methods: {
    makeEditSetCall() {
      if (this.loadEntityOnCreate && this.entityId) {
        this.hasDataLoading(() => { this.setDataLoading(true); });
        this.loadEntityForEdit();
      }
    },
    loadEntityForEdit() {
      this.requestClass.get(this.entityId)
        .then(({ data }) => this.setEntityData(data))
        .catch((error) => {
          console.log(error);
        }).finally(() => {
          this.hasDataLoading(() => { this.setDataLoading(false); });
        });
    },
    setEntityData(data) {
      this.payload = data;
    },
    isValidated() {
      return this.$refs[this.formsRef].validate();
    },
    validateForm() {
      if (!this.isValidated()) {
        this.showFormsErrors();
        return false;
      }
      return true;
    },
    showFormsErrors() {
      this.showErrorToast({
        title: 'Ocorreu um erro!',
        text: 'Preencha os dados corretamente.',
      });
    },
    save() {
      if (this.validateForm()) {
        this.hasDataLoading(() => { this.setDataLoading(true); });
        if (this.entityId) {
          this.update();
        } else {
          this.create();
        }
      }
    },
    getCreatePayload() {
      return this.payload;
    },
    getDataResponse(response) {
      return response
        && response.data && response.data.data
        ? response.data.data : {};
    },
    create() {
      this.loadingForm = true;
      if (this.onSaveExtraClass) {
        this.onSaveExtraClass();
      }
      this.requestClass.save(this.getCreatePayload())
        .then((response) => {
          if (this.calledInsideSave) {
            this.calledInsideSave(
              this.getDataResponse(response),
            )
              .then(() => {
                this.successCreateCb(response.data);
              }).catch((err) => {
                this.errorCreateCb(err);
              });
          } else {
            this.successCreateCb(response.data);
          }
        }).catch((err) => {
          this.errorCreateCb(err);
        })
        .finally(() => {
          this.loadingForm = false;
          this.hasDataLoading(() => { this.setDataLoading(false); });
        });
    },
    successCreateCb(data) {
      if (this.showSuccessToastMessage) {
        this.showSuccessToast({
          title: 'Sucesso!',
          text: this.successToasMessageCreate,
        });
      }
      this.$emit('success', data || true);
      this.afterSave();
    },
    errorCreateCb(err) {
      this.showMessageError(err.response);
    },
    afterSave() {
      if (this.navigateToPageAfterSave) {
        this.navigateTo(this.navigateToPageAfterSave, this.navigateBackParams);
      }
    },
    getEditPayload() {
      return this.payload;
    },
    showMessageError(response) {
      console.log(response);
      this.showErrorToast(
        this.makeMessageErrorBody(response),
      );
    },
    makeMessageErrorBody(response) {
      return {
        text: this.verifyResponseMessage(
          response,
        ),
      };
    },
    verifyResponseMessage(response) {
      let message = 'Falha ao se comunicar com o servidor.';

      if (response && response.data && response.data.message) {
        message = response.data.message;
      }

      return message;
    },
    update() {
      this.loadingForm = true;
      if (this.onEditExtraClass) {
        const request = this.onEditExtraClass();
        if (request instanceof Promise) {
          request
            .then(() => {
              this.makeEditRequest();
            }).catch((err) => {
              this.loadingForm = false;
              this.showMessageError(err.response);
            });
        } else {
          this.makeEditRequest();
        }
      } else {
        this.makeEditRequest();
      }
    },
    makeEditRequest() {
      this.requestClass.edit(this.entityId, this.getEditPayload())
        .then((response) => {
          if (this.calledInsideEdit) {
            try {
              this.calledInsideEdit(
                this.getDataResponse(response),
              )
                .then(() => {
                  this.successEditCb();
                }).catch((err) => {
                  this.showMessageError(err.response);
                });
            } catch (err) {
              this.showMessageError(err);
            }
          } else {
            this.successEditCb();
          }
          return response;
        }).catch((err) => {
          this.showMessageError(err.response);
        }).finally(() => {
          this.loadingForm = false;
          this.hasDataLoading(() => { this.setDataLoading(false); });
        });
    },
    successEditCb() {
      this.showSuccessToast({
        text: 'Os dados foram atualizados.',
      });

      this.$emit('success', true);

      this.afterSave();
    },
    hasDataLoading(cb) {
      if (this.setDataLoading) {
        cb();
      }
    },
  },
};
